import { z } from "zod";

// 115 -- record a point won by a side.
export const recordTennisPointSchema = z.object({
  point_winner: z.enum(["home", "away"]),
});

// Optional best-of override when the result row is first created.
export const startTennisSchema = z.object({
  best_of_sets: z.union([z.literal(3), z.literal(5)]).optional(),
});

export type RecordTennisPointInput = z.infer<typeof recordTennisPointSchema>;
export type StartTennisInput = z.infer<typeof startTennisSchema>;
